import React, { useEffect, Fragment, useContext } from "react";
import PropTypes from "prop-types";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import useGet from "../../hooks/useGet";

import Icon from "../Icon";

import SearchResult from "./SearchResult";
import Loading from "../Loading";

const SearchResults = ({ url, params, setQuery, setError, reset }) => {
  const context = useContext(EligibilityContext);
  const [loading, response, error] = useGet(url, {
    params: params,
  });

  const handleNoFund = (event) => {
    event.preventDefault();
    setQuery("");
    context.actions.setStep(8);
    context.actions.setModalOpen(true);
  };

  if (error) {
    setQuery("");
    context.actions.renderError();
  }

  const filterFunds = (funds) => {
    return funds.filter((fund) => {
      if (!fund.Fund_Name || !fund.permalink) {
        return false;
      } else {
        return true;
      }
    });
  };

  return (
    <div className="QuickSearch-results" role="alert" aria-live="polite">
      {loading && <Loading className="Loading--small" label="Searching..." />}

      {response && response.data && response.data.funds && response.data.funds.length !== 0 && (
        <Fragment>
          <p className="f-label c-purple">Select a Fund</p>

          <ol>
            {filterFunds(response.data.funds)
              .slice(0, 10)
              .map((result, i) => (
                <SearchResult
                  key={i}
                  result={result}
                  setError={setError}
                  setQuery={setQuery}
                />
              ))}
            <li className="QuickSearch-results-item QuickSearch-results-noFund f-scale-body">
              <button
                className="btn-reset"
                type="button"
                onClick={handleNoFund}
              >
                I do not see the help I need
              </button>
            </li>
          </ol>
        </Fragment>
      )}

      {response && response.data.count === 0 && (
        <div className="u-richtext">
          <p
            className="f-scale-body"
            style={{ marginTop: 10, marginBottom: 10 }}
          >
            Sorry, there are no medications or diseases associated with your
            search. We still may be able to help.{" "}
            <a href="/contact">
              Contact us
            </a>
            .
          </p>
        </div>
      )}

      {response && (
        <button
          className="QuickSearch-results-clear btn-reset"
          type="button"
          onClick={reset}
        >
          <div className="u-screenreader">Clear Form</div>
          <Icon name="close" width="16" height="16" />
        </button>
      )}
    </div>
  );
};

SearchResults.propTypes = {
  url: PropTypes.string.isRequired,
  params: PropTypes.object,
  setQuery: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

export default SearchResults;
